import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

export const LISTING_COLUMNS = [
  {
    id: 'data',
    label: 'Data',
    width: '15%',
    align: 'left',
    dataKey: 'data',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'dataName',
    label: 'Current Data Name',
    width: '15%',
    align: 'left',
    dataKey: 'dataName',
    // sortable: true,
    type: CELL_DATA_TYPES.CURRENT_DATA_NAME,
  },
  {
    id: 'changedBy',
    label: 'Changed By',
    width: '15%',
    align: 'left',
    dataKey: 'changeBy',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'fieldChanges',
    label: 'Field Changes',
    width: '15%',
    align: 'left',
    dataKey: 'fieldChange',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'changeddate',
    label: 'Changed Date',
    width: '15%',
    align: 'left',
    dataKey: 'changeDate',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'data',
    label: 'Data',
    width: '15%',
    align: 'left',
    dataKey: 'data',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'dataName',
    label: 'Current Data Name',
    width: '15%',
    align: 'left',
    dataKey: 'dataName',
    type: CELL_DATA_TYPES.CURRENT_DATA_NAME,
  },
  {
    id: 'changedBy',
    label: 'Changed By',
    width: '15%',
    align: 'left',
    dataKey: 'changeBy',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'changeddate',
    label: 'Changed Date',
    width: '15%',
    align: 'left',
    dataKey: 'changeDate',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const VIEW_DATA_COLUMNS = [
  {
    id: 'field',
    label: 'Field',
    width: '15%',
    align: 'left',
    dataKey: 'label',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'oldData',
    label: 'Old Data',
    width: '15%',
    align: 'left',
    dataKey: 'oldData',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'newData',
    label: 'New Data',
    width: '15%',
    align: 'left',
    dataKey: 'newData',
    type: CELL_DATA_TYPES.TEXT,
  },
];
